<template>
    <div class="sec-cont">
        <Head :title="title" />
        <div class="bg-white rounded-md shadow overflow-hidden w-full">
            <form @submit.prevent="update">
                <div class="p-4 flex flex-wrap">
                    <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Slug')" />
                </div>
                <div class="p-4 flex flex-col gap-10">
                    <h2 class="h2">Permissions List</h2>
                    <div v-for="permission in permissions" :key="permission.id">
                        <label :for="`permission_${permission.id}`" class="flex items-center cursor-pointer space-x-3">
                            <span class="text-sm font-medium text-gray-700">{{ permission.name }}</span>
                            <div class="relative inline-block w-12 h-7">
                                <input
                                    :id="`permission_${permission.id}`"
                                    type="checkbox"
                                    class="sr-only"
                                    v-model="form.permissions"
                                    :value="permission.id"
                                />
                                <div class="role-block bg-gray-300 w-full h-full rounded-full transition"></div>
                                <div class="dot absolute left-1 top-1 bg-white w-5 h-5 rounded-full transition-transform transform"
                                     :class="{ 'translate-x-5': form.permissions.includes(permission.id) }">
                                </div>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo() {
        return { title: this.form.name }
    },
    components: {
        LoadingButton,
        TextInput,
        Link,
        Head,
    },
    layout: Layout,
    props: {
        title: String,
        name: String,
        slug: String,
        role:Object,
        permissions: Array,
        assignedPermissions: {
            type: Array,
            default: () => []
        }
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.name,
                slug: this.slug,
                permissions: [...this.assignedPermissions], // Initialize with assigned permissions
            }),
        }
    },
    methods: {
        update() {
            this.form.put(this.route('roles.update', this.role.id))
        },
        destroy() {
            if (confirm('Are you sure you want to delete this role?')) {
                this.$inertia.delete(this.route('roles.destroy', { role: this.role.id }));
            }
        }
    },
    mounted() {
        // Ensure initial permissions are loaded properly
        console.log("Initialized permissions:", this.form.permissions);
    },
}
</script>
